/*
* Fix the header when scrolling
*/

const header = document.querySelector('.wcl-main-header');

if (header) {
   window.addEventListener('scroll', function () {
      if (window.scrollY > 1) {
         header.classList.add('fixed');
      } else {
         header.classList.remove('fixed');
      }
   });
}
